module.exports = __webpack_public_path__ + "public/SiteIcons/starReview.svg?42322daf";